import { useSeo } from '@/hooks/useSeo';
import Hero from '@/pages/home/components/Hero';
import TrackingSection from '@/pages/home/components/TrackingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import HotSection from '@/pages/home/components/HotSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FaqPreview from '@/pages/home/components/FaqPreview';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '策驰漫画网',
      url: 'https://gifcart.github.io/',
      description: '抢先看最新话，同步更新进度，汉化进度实时查的漫画追更平台。',
    },
    {
      '@type': 'WebSite',
      name: '策驰漫画网',
      url: 'https://gifcart.github.io/',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://gifcart.github.io/comics?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '如何查看漫画的同步更新进度与汉化进度？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '进入任意漫画详情页，即可看到同步更新进度和汉化进度两个进度条，一目了然。',
          },
        },
        {
          '@type': 'Question',
          name: '什么是抢先看？如何第一时间看到最新话？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '抢先看是平台为热门连载提供的及时更新栏目，最新话上线后会第一时间出现在首页今日更新和漫画详情页最顶端。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  useSeo({
    title: '策驰漫画网 - 抢先看最新话，同步更新进度与汉化进度实时查',
    description:
      '打开策驰漫画网，第一时间掌握最新话与抢先看内容。热门连载最新话、同步更新进度、汉化进度一目了然，追更不再错过。',
    keywords: '策驰漫画网,策驰漫画网更新,策驰漫画网抢先看,策驰漫画网最新话,策驰漫画网追更进度,策驰漫画网同步更新,策驰漫画网汉化进度',
  });

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Hero />
      <TrackingSection />
      <UpdatesSection />
      <CategoriesSection />
      <HotSection />
      <AboutSection />
      <FaqPreview />
    </>
  );
}